/**
 * @file        src/pages/insurance/CorporatePolicyRequests.jsx
 * @description Corporate Insurance → Policy Requests. The same queue as the B2C
 *              screen, fixed to audience=b2b rather than forking the page.
 * @author      Kinetika Labs
 * @created     2026-09-22
 * @changelog
 *   - 2026-09-22 Claude — Initial.
 */
import PolicyRequests from './PolicyRequests';

export default function CorporatePolicyRequests() {
  return (
    <PolicyRequests
      title="Corporate Policy Requests"
      subtitle="Corporate Insurance · policy document requests"
      audience="b2b"
    />
  );
}
